import { combineReducers } from 'redux';
import roundReducer from './reducers/roundReducer';
import instructionReducer from './reducers/instructionReducer';

export const reducerCollection = {
  round: roundReducer,
  instruction: instructionReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
